export const uploadRecordingToDigitalOcean = async ({
  uploadUrl,
  blob,
  contentType,
}) => {
  if (!uploadUrl) {
    throw new Error("Missing DigitalOcean upload URL.");
  }

  if (!blob) {
    throw new Error("Missing recording file.");
  }

  let response;

  try {
    response = await fetch(uploadUrl, {
      method: "PUT",
      // Match the recording's type so the stored object is served correctly.
      headers: { "Content-Type": contentType || blob.type || "video/webm" },
      body: blob,
    });
  } catch (err) {
    // fetch() only rejects when the request never completed — i.e. it was never
    // actually sent/received: a CORS preflight rejection, DNS/TLS failure, or
    // the network dropping. The browser reports all of these as the unhelpful
    // "Failed to fetch", so make step 2 say what really happened.
    throw new Error(
      "Upload could not be sent to storage (step 2). The request was blocked " +
        "before it reached DigitalOcean — usually a CORS rule missing on the " +
        "Space, or a network/connection problem. " +
        `(${err?.message || "Failed to fetch"})`
    );
  }

  if (!response.ok) {
    // The request reached DigitalOcean but it rejected it (e.g. expired/invalid
    // presigned URL, signature mismatch, permissions).
    let message = `Storage rejected the upload (step 2) with status ${response.status}`;

    try {
      const text = await response.text();

      if (text) {
        message = `${message}: ${text}`;
      }
    } catch {
      // ignore
    }

    throw new Error(message);
  }

  return {
    success: true,
    status: response.status,
    etag: response.headers.get("ETag"),
  };
};
